import { TextInputMoneyMask } from "../../Form/TextInputMoneyMask"

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    label?: string
    name?: string
}

export function SearchMinMoney({onChange, onBlur, label='Valor mínimo', name='min_money'}: Props) {
    return (
        <div className='col-12 col-lg-2 mb-5'>
            <TextInputMoneyMask
                label={label}
                placeholder='Ex: R$10'
                name={name}
                onChange={onChange}
                onBlur={onBlur}
            />
        </div>
    )
}
